import UserEntity from '../../entities/user/user_entity';
import User from '../../presentation_models/user/user';

const userConverter = (user: UserEntity) => {
   /* Nothing to convert here at the moment but just using this as
   an example of how we can use the converter in the future */
   return new User({...user.toObject()});
};

export default userConverter;
